// extracted by mini-css-extract-plugin
export default {"toggle":"styles__toggle___AubFL","thumb":"styles__thumb___KZX_V","track":"styles__track___mKaQV","invisible":"styles__invisible___xpKfz"};